import React, { Component } from 'react';
import ContentPanel from '../../components/ContentPanel/ContentPanel';
import Skeleton from '../../components/Skeleton/Skeleton';
import CardsList from '../../components/CardsList/CardsList';
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import {REQUEST_CUSTOMER_TESTIMONIALS_DATA} from "../../actions/customerTestimonialsActions";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import store from "../../store";
import {Helmet} from "react-helmet";

const mapStateToProps = state => {
  return {
    customerTestimonialsData: state.customerTestimonialsData
  };
};

const mapDispatchToProps = dispatch => ({
  getCustomerTestimonialsData: () => dispatch({type: REQUEST_CUSTOMER_TESTIMONIALS_DATA})
});

class CustomerTestimonials extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.customerTestimonialsData).length) {
      this.props.getCustomerTestimonialsData();
    }
  };

  render() {
    return (
      <div className="wrapper">
          <Helmet>
              {
                  store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                      return row.rowTitle === "About" ? row.sections.map((section) => {
                          return section.title === "Customer Testimonials" ? <meta name="description" content={section.content['seo-description']}/> : null
                      }) : null
                  }) : null
              }
          </Helmet>
        <Breadcrumbs/>
        <ContentPanel
          skeleton={<Skeleton type="MAIN_PANEL" />}
          errorTemplate={<Skeleton type="MAIN_PANEL_ERROR" />}
          templateUrl="./content/about/page-components/text-block/customer-testimonials-heading.html"
        />
        <CardsList
          layoutData={Object.keys(this.props.customerTestimonialsData).length ? this.props.customerTestimonialsData.customerTestimonials : null}
          pathForItem="/about/customer-testimonials/customer-testimonial"
          hasViewSwitcher={false}
          hasCardsView={true}
          showDatesOfIndividualContent={true}
        />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerTestimonials));



// WEBPACK FOOTER //
// ./src/pages/About/CustomerTestimonials.js